<template>
    <a :href="exhibitor.detail_uri" class="exhibitor" :target="newTab ? '_blank' : '_self'" v-if="exhibitor.detail_uri">
        <div>
            <img :src="exhibitor.logo" v-if="exhibitor.logo" class="img-fluid">
        </div>
        <div class="ps-2 pt-1">
            <i class="fa favorite clickable" v-if="!hideFavorite" :class="{ 'fa-heart-o' : !exhibitor.favorited, 'fa-heart' : exhibitor.favorited }" @click.prevent="toggleFavorite"></i>
            <div class="me-3 overflow-hidden name">{{ exhibitor.name }}</div>
            <div class="stand position-absolute bottom-0 text-muted">
                {{ exhibitor.stand }}
            </div>
            <div v-if="exhibitor.sectors && exhibitor.sectors.length" class="sectors">
                <i class="fa fa-circle ms-1" :style="{ color : sector.color }" v-for="sector in exhibitor.sectors"></i>
            </div>
        </div>
    </a>
    <div v-else class="exhibitor">
        <div>
            <img :src="exhibitor.logo" v-if="exhibitor.logo" class="img-fluid">
        </div>
        <div class="ps-2 pt-1">
            <i class="fa favorite clickable" v-if="!hideFavorite" :class="{ 'fa-heart-o' : !exhibitor.favorited, 'fa-heart' : exhibitor.favorited }" @click.prevent="toggleFavorite"></i>
            <div class="me-3 overflow-hidden name">{{ exhibitor.name }}</div>
            <div class="stand position-absolute bottom-0 text-muted">
                {{ exhibitor.stand }}
            </div>
            <div v-if="exhibitor.sectors && exhibitor.sectors.length" class="sectors">
                <i class="fa fa-circle ms-1" :style="{ color : sector.color }"  v-for="sector in exhibitor.sectors"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['exhibitor', 'hide-favorite', 'new-tab'],
        data() {
            return {
                //
            }
        },
        methods: {
            toggleFavorite() {
                axios.post('/favorite-exhibitors/'+ this.exhibitor.id +'/toggle')
                     .then(response => {
                         this.exhibitor.favorited = !this.exhibitor.favorited;
                     });
            },
        },
        mounted() {
            //
        }
    }
</script>
